module.exports = __webpack_public_path__ + "static/media/exitIconLight.e7036ed1.svg";